//Custom icons
"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("@mui/icons-material/utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d:`
  M 22.7843 21.2333
  V 19.3888
  h -2.82912
  v -2.76674
  h -1.88607
  v 2.76674
  h -2.82911
  v 1.84449 
  h 2.82911 
  V 24 
  h 1.88607 
  V 21.2333 
  Z 
  
  M 18.0886 1.84449 
  H 4.88607 
  V 19.473 
  h 8.79619 
  v 1.84449 
  H 4.88607 
  C 3.84874 21.3175 3 20.4875 3 19.473 
  V 1.84449 
  C 3 0.830022 3.84874 0 4.88607 0 
  h 13.2025 
  c 1.03734 0 1.88607 0.830022 1.88607 1.84449 
  V 14.7996 
  h -1.88607 
  Z
  `
}), 'StormRounded');